import {FormControl, FormHelperText, FormLabel} from "@mui/material";
import React from "react";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {withSharedMemo} from "./memo/memoComponent";
import {CommonProps} from "./types/types";
import DisplayTextComponent from "./DisplayTextComponent";
import {BaseInput} from "./BaseInput";

interface TextFieldComponentProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
    id: string
}

const TextFieldComponent = ({
                                required,
                                editable,
                                displayText,
                                value,
                                onChange,
                                errorText,
                                onFocus = undefined,
                                status = StatusUpdateAnswer.NONE,
                                id,
                                hint
                            }: TextFieldComponentProps) => {

    const hasError = !!errorText;

    return (
            <>
                <FormControl disabled={!editable} required={required}>
                    <FormLabel error={hasError} required={false}>
                        <DisplayTextComponent text={displayText} required={required} hint={hint}/>
                    </FormLabel>
                    <BaseInput
                            id={id}
                            value={value}
                            onChange={onChange}
                            onFocus={onFocus}
                            editable={editable}
                            required={required}
                            hasError={hasError}
                            type="text"
                            status={status}
                    />
                    {hasError ? <FormHelperText error>{errorText}</FormHelperText> : null}
                </FormControl>
            </>
    )
};

export default withSharedMemo(TextFieldComponent);